/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTouchpad: {
  name: 'touchpad';
  data: string;
} = {
  name: 'touchpad',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm11 12h7v-2h-7v2Zm-2-2v2H4v-2h7Zm1-2h8V6H4v8h8Z" fill="currentColor"/></svg>`,
};
